import _classCallCheck from '/app/node_modules/babel-runtime/helpers/classCallCheck';
import _createClass from '/app/node_modules/babel-runtime/helpers/createClass';
export var MembershipApi = function () {
    function MembershipApi(axios) {
        _classCallCheck(this, MembershipApi);

        this.axios = axios;
    }

    _createClass(MembershipApi, [{
        key: 'getMasterData',
        value: function getMasterData() {
            return this.axios.$get('/membership-data/getMasterData');
        }
    }, {
        key: 'getCommercialBusiness',
        value: function getCommercialBusiness() {
            return this.axios.$get('/membership-data/getCommercialBusiness');
        }
    }]);

    return MembershipApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/membership-data.js
// module id = ./src/api/membership-data.js
// module chunks = 34